// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */

import type * as Types from '../../../../../../../../schema';

import useSubscription from '@/client/hooks/useSubscription';
import gql from '@/shared/utils/gql';
export type MyWithdrawalChangedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type MyWithdrawalChangedSubscription = { __typename?: 'Subscription', bankingMyWithdrawChanged?: { __typename?: 'BankingMyWithdrawChangedSubscriptionPayload', changedTransaction?: { __typename?: 'BankingTransaction', id: string, rawId?: string, txType?: Types.BankingTransactionType, amount?: number, currency?: string, endingBalance?: number, status?: Types.BankingTransactionStatus, createTime?: number, description?: string, confirmations?: number, txId?: string, address?: string, provider?: string, txAction?: Types.TransactionActionTypes, providerMethod?: string } } };

export type TransactionNodeFragment = { __typename?: 'BankingTransaction', id: string, rawId?: string, txType?: Types.BankingTransactionType, amount?: number, currency?: string, endingBalance?: number, status?: Types.BankingTransactionStatus, createTime?: number, description?: string, confirmations?: number, txId?: string, address?: string, provider?: string, txAction?: Types.TransactionActionTypes, providerMethod?: string };

export const TransactionNodeFragmentDoc = gql`
    fragment TransactionNode on BankingTransaction {
  id
  rawId
  txType
  amount
  currency
  endingBalance
  status
  createTime
  description
  confirmations
  txId
  address
  provider
  txAction
  providerMethod
}
    `;
export const MyWithdrawalChangedSubscriptionDocument = gql`
    subscription MyWithdrawalChangedSubscription {
  bankingMyWithdrawChanged(input: {}) {
    changedTransaction {
      ...TransactionNode
    }
  }
}
    ${TransactionNodeFragmentDoc}`;

export const useMyWithdrawalChangedSubscription = (options: { variables?: MyWithdrawalChangedSubscriptionVariables, onData: (data: MyWithdrawalChangedSubscription) => void } ) => { 
  return useSubscription<MyWithdrawalChangedSubscription, MyWithdrawalChangedSubscriptionVariables>(MyWithdrawalChangedSubscriptionDocument, options);
}